export default __webpack_public_path__ + "static/media/Deployment.1b4e7206.svg";